<template>
    <div class="match-details__stats-container">
        <div class="match-detail__stats-wrapper">
            <div class="analysis-title">
                {{ $t("LEAGUE_STATS_COMPARISON") }}
            </div>
            <div class="analysis-hint-text">
                {{ $t("LATEST_5_MATCHES") }}
            </div>

            <!-- mobile ------------------------------------------------ -->
            <template v-if="isMobile">
                <template v-for="(o, index) in dataLabel" :key="index">
                    <div
                        v-if="
                            (type === 'component' && index < 3) ||
                            type !== 'component'
                        "
                    >
                        <div class="match-detail__stats-card">
                            <!-- circle progress -->
                            <div
                                v-if="o.type === 'circle'"
                                class="display-flex-center w-100 match-detail__stats-item-box"
                            >
                                <div
                                    class="progress-circle circle-home"
                                    :style="`--progress:${progressWidth(
                                        o.dataKey,
                                        'home',
                                        '%'
                                    )}`"
                                    :data-progress="
                                        progressWidth(o.dataKey, 'home', '%')
                                    "
                                ></div>

                                <div class="circle-progress-title">
                                    {{ $t(o.name) }}
                                </div>

                                <div
                                    class="progress-circle circle-away"
                                    :style="`--progress:${progressWidth(
                                        o.dataKey,
                                        'away',
                                        '%'
                                    )}`"
                                    :data-progress="
                                        progressWidth(o.dataKey, 'away', '%')
                                    "
                                ></div>
                            </div>

                            <div
                                class="display-flex-center w-100 match-detail__stats-item-box"
                                v-if="o.type === 'progress-bar'"
                            >
                                <div class="w-100 dashed-box">
                                    <div class="match-detail__stats-number">
                                        {{ homeTeam[o.dataKey] ?? "-" }}
                                    </div>
                                    <div class="match-detail__stats-container">
                                        <div
                                            class="match-detail__stats-container mr-05rem"
                                        >
                                            <div
                                                class="match-detail__stats-progress-wrapper"
                                            >
                                                <div
                                                    class="match-detail__stats-progress-bar"
                                                    :style="{
                                                        borderRadius:
                                                            borderRadius(
                                                                o.dataKey
                                                            ),
                                                        width: progressWidth(
                                                            o.dataKey,
                                                            'home',
                                                            '%'
                                                        ),
                                                        opacity: opacity(
                                                            progressWidth(
                                                                o.dataKey,
                                                                'home'
                                                            ),
                                                            progressWidth(
                                                                o.dataKey,
                                                                'away'
                                                            )
                                                        ),
                                                    }"
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="match-detail__stats-title dashed-box"
                                >
                                    {{ $t(o.name) }}
                                </div>

                                <div
                                    class="w-100 dashed-box match-detail__stats-item-box"
                                >
                                    <div
                                        class="w-100 match-detail__stats-number right"
                                    >
                                        {{ awayTeam[o.dataKey] ?? "-" }}
                                    </div>
                                    <div class="match-detail__stats-container">
                                        <div
                                            class="match-detail__stats-progress-wrapper right"
                                        >
                                            <div
                                                class="match-detail__stats-progress-bar"
                                                :style="{
                                                    borderRadius: borderRadius(
                                                        o.dataKey
                                                    ),
                                                    width: progressWidth(
                                                        o.dataKey,
                                                        'away',
                                                        '%'
                                                    ),
                                                    opacity: opacity(
                                                        progressWidth(
                                                            o.dataKey,
                                                            'away'
                                                        ),
                                                        progressWidth(
                                                            o.dataKey,
                                                            'home'
                                                        )
                                                    ),
                                                }"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
            <!-- web ------------------------------------------------ -->
            <template v-else>
                <div class="display-flex match-stats-web-container">
                    <div class="match-stats-web-left">
                        <template v-for="(o, index) in dataLabel" :key="index">
                            <div
                                v-if="
                                    (type === 'component' && index < 3) ||
                                    type !== 'component'
                                "
                            >
                                <div
                                    class="match-detail__stats-card"
                                    v-if="o.type === 'progress-bar'"
                                >
                                    <div
                                        class="display-flex-center w-100 match-detail__stats-item-box"
                                    >
                                        <div class="w-100 dashed-box">
                                            <div
                                                class="match-detail__stats-number"
                                            >
                                                {{ homeTeam[o.dataKey] ?? "-" }}
                                            </div>
                                            <div
                                                class="match-detail__stats-container"
                                            >
                                                <div
                                                    class="match-detail__stats-container mr-05rem"
                                                >
                                                    <div
                                                        class="match-detail__stats-progress-wrapper"
                                                    >
                                                        <div
                                                            class="match-detail__stats-progress-bar"
                                                            :style="{
                                                                borderRadius:
                                                                    '8px',
                                                                width: progressWidth(
                                                                    o.dataKey,
                                                                    'home',
                                                                    '%'
                                                                ),
                                                                opacity:
                                                                    opacity(
                                                                        progressWidth(
                                                                            o.dataKey,
                                                                            'home'
                                                                        ),
                                                                        progressWidth(
                                                                            o.dataKey,
                                                                            'away'
                                                                        )
                                                                    ),
                                                            }"
                                                        ></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            class="match-detail__stats-title dashed-box"
                                        >
                                            {{ $t(o.name) }}
                                        </div>

                                        <div
                                            class="w-100 dashed-box match-detail__stats-item-box"
                                        >
                                            <div
                                                class="w-100 match-detail__stats-number right"
                                            >
                                                {{ awayTeam[o.dataKey] ?? "-" }}
                                            </div>
                                            <div
                                                class="match-detail__stats-container"
                                            >
                                                <div
                                                    class="match-detail__stats-progress-wrapper right"
                                                >
                                                    <div
                                                        class="match-detail__stats-progress-bar"
                                                        :style="{
                                                            borderRadius: '8px',
                                                            width: progressWidth(
                                                                o.dataKey,
                                                                'away',
                                                                '%'
                                                            ),
                                                            opacity: opacity(
                                                                progressWidth(
                                                                    o.dataKey,
                                                                    'away'
                                                                ),
                                                                progressWidth(
                                                                    o.dataKey,
                                                                    'home'
                                                                )
                                                            ),
                                                        }"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="match-stats-web-right">
                        <template v-for="(o, index) in dataLabel" :key="index">
                            <div
                                v-if="
                                    (type === 'component' && index < 3) ||
                                    type !== 'component'
                                "
                            >
                                <div
                                    class="match-detail__stats-card"
                                    v-if="o.type === 'circle'"
                                >
                                    <!-- circle progress -->
                                    <div
                                        class="display-flex-center w-100 match-detail__stats-item-box"
                                    >
                                        <div
                                            class="progress-circle circle-home"
                                            :style="{
                                                opacity: opacity(
                                                    progressWidth(
                                                        o.dataKey,
                                                        'home'
                                                    ),
                                                    progressWidth(
                                                        o.dataKey,
                                                        'away'
                                                    )
                                                ),
                                                '--progress': progressWidth(
                                                    o.dataKey,
                                                    'home',
                                                    '%'
                                                ),
                                            }"
                                            :data-progress="
                                                progressWidth(
                                                    o.dataKey,
                                                    'home',
                                                    '%'
                                                )
                                            "
                                        ></div>

                                        <div class="circle-progress-title">
                                            {{ $t(o.name) }}
                                        </div>

                                        <div
                                            class="progress-circle circle-away"
                                            :style="{
                                                opacity: opacity(
                                                    progressWidth(
                                                        o.dataKey,
                                                        'away'
                                                    ),
                                                    progressWidth(
                                                        o.dataKey,
                                                        'home'
                                                    )
                                                ),
                                                '--progress': progressWidth(
                                                    o.dataKey,
                                                    'away',
                                                    '%'
                                                ),
                                            }"
                                            :data-progress="
                                                progressWidth(
                                                    o.dataKey,
                                                    'away',
                                                    '%'
                                                )
                                            "
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
            <div
                class="show-more"
                @click="seeAll()"
                v-if="type === 'component'"
            >
                {{ showMore ? $t("SEE_LESS") : $t("SEE_ALL") }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import MatchListDropdown from "../../ui/MatchListDropdown.vue";
// import GeneralContentSkeleton from '@/components/skeletonLoading/GeneralContentSkeleton.vue';

export default {
    props: {
        type: String,
    },
    data() {
        return {
            dataLabel: [
                {
                    name: "WIN",
                    dataKey: "winRate",
                    type: "circle",
                },
                {
                    name: "DRAW",
                    dataKey: "drawRate",
                    type: "circle",
                },
                {
                    name: "LOSE",
                    dataKey: "loseRate",
                    type: "circle",
                },
                {
                    name: "TOTAL_GOALS",
                    dataKey: "totalGoal",
                    type: "progress-bar",
                },
                {
                    name: "TOTAL_GOALS_CONCEDED",
                    dataKey: "totalGoalLose",
                    type: "progress-bar",
                },
                {
                    name: "GOAL_DIFF",
                    dataKey: "totalNettGoal",
                    type: "progress-bar",
                },
                {
                    name: "GOALS_PER_GAME",
                    dataKey: "averageGoal",
                    type: "progress-bar",
                },
                {
                    name: "SAME_SIDE_WIN",
                    dataKey: "standingWinRate",
                    type: "circle",
                },
                {
                    name: "SAME_SIDE_DRAW",
                    dataKey: "standingDrawRate",
                    type: "circle",
                },
                {
                    name: "SAME_SIDE_LOSE",
                    dataKey: "standingLoseRate",
                    type: "circle",
                },
                {
                    name: "SAME_SIDE_GOAL",
                    dataKey: "standingGoal",
                    type: "progress-bar",
                },
                {
                    name: "SAME_SIDE_CONCEDED",
                    dataKey: "standingGoalLose",
                    type: "progress-bar",
                },
                {
                    name: "SAME_SIDE_DIFF",
                    dataKey: "standingNettGoal",
                    type: "progress-bar",
                },
                {
                    name: "SAME_SIDE_AVG",
                    dataKey: "standingAverageGoal",
                    type: "progress-bar",
                },
            ],
            showMore: false,

            headerLabel: [
                "TEAM",
                "TOTAL_GOALS",
                "TOTAL_GOALS_CONCEDED",
                "GOAL_DIFF",
                "GOALS_PER_GAME",
                "W",
                "DRAW",
                "L",
                "SAME_SIDE_GOAL",
                "SAME_SIDE_CONCEDED",
                "SAME_SIDE_DIFF",
                "SAME_SIDE_AVG",
                "SAME_SIDE_WIN",
                "SAME_SIDE_DRAW",
                "SAME_SIDE_LOSE",
            ],
            objectOrder: [
                "totalGoal",
                "totalGoalLose",
                "totalNettGoal",
                "averageGoal",
                "winRate",
                "drawRate",
                "loseRate",
                "standingGoal",
                "standingGoalLose",
                "standingNettGoal",
                "standingAverageGoal",
                "standingWinRate",
                "standingDrawRate",
                "standingLoseRate",
            ],
            isNoData: false,
            result: "",
            devResult: "",
            round: 1,
            isSkeletonLoading: {
                lastNMatches: false,
            },
        };
    },
    mounted() {
        this.getLastNMatchesData();
    },
    watch: {
        type(newVal) {},
        manualRefreshMatchDetail: {
            deep: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    this.getLastNMatchesData();
                }
            },
        },
    },
    computed: {
        ...mapGetters([
            "isMobile",
            "currentLocale",
            "currentSportType",
            "manualRefreshMatchDetail",
        ]),
        homeTeam() {
            return this.result && this.result[this.round - 1].homeTeam;
        },
        awayTeam() {
            return this.result && this.result[this.round - 1].awayTeam;
        },
        roundList() {
            let round = [];
            for (let i = 1; i < this.result.length + 1; i++) {
                round.push(i);
            }
            return round;
        },
    },
    methods: {
        ...mapActions(["getLastNMatches"]),
        opacity(self, other) {
            if (self != 0) {
                if (self < other) {
                    return 0.24;
                }
                return 1;
            }
            return 1;
        },
        borderRadius(dataKey) {
            let radius = "0px";
            if (this.isMobile) {
                radius = "8px";
            } else if (this.homeTeam[dataKey] && this.awayTeam[dataKey]) {
                if (
                    (parseFloat(this.homeTeam[dataKey]) /
                        (parseFloat(this.homeTeam[dataKey]) +
                            parseFloat(this.awayTeam[dataKey]))) *
                        100 ===
                        0 ||
                    (parseFloat(this.homeTeam[dataKey]) /
                        (parseFloat(this.homeTeam[dataKey]) +
                            parseFloat(this.awayTeam[dataKey]))) *
                        100 >
                        98
                ) {
                    radius = "8px";
                } else {
                    radius = "0 8px 8px 0";
                }
            } else {
                radius = "8px";
            }
            return radius;
        },
        progressWidth(dataKey, type, suffix = "") {
            let self = 0;
            let other = 0;
            if (type === "home") {
                self = this.homeTeam[dataKey];
                other = this.awayTeam[dataKey];
            } else {
                self = this.awayTeam[dataKey];
                other = this.homeTeam[dataKey];
            }
            let result = 0;
            if (self === null) {
                result = 0;
            } else if (self !== 0) {
                if (self === 0) {
                    result = 0;
                } else if (other < 0) {
                    result = 100;
                } else {
                    result =
                        (parseFloat(self) /
                            (parseFloat(self) + parseFloat(other))) *
                        100;
                }
            } else if (self === 0 || self < 0) {
                result = 0;
            }
            return result + suffix;
        },
        async getLastNMatchesData() {
            if (this.manualRefreshMatchDetail) {
                this.isSkeletonLoading.lastNMatches = true;
            }
            const result = await this.getLastNMatches({
                matchId: this.$route.params.matchId,
            });
            if (this.manualRefreshMatchDetail) {
                this.isSkeletonLoading.lastNMatches = false;
                this.verifyIfAllAPICallsDone();
            }
            result.result
                ? (this.result = result.result.matches)
                : (this.isNoData = true);
        },
        checkNull(data, pos) {
            if (data || data === 0) {
                if (
                    pos === 4 ||
                    pos === 5 ||
                    pos === 6 ||
                    pos === 11 ||
                    pos === 12 ||
                    pos === 13
                ) {
                    return data + "%";
                } else return data;
            } else return "-";
        },
        updateLength(data) {
            this.round = data;
        },
        verifyIfAllAPICallsDone() {
            if (!this.isSkeletonLoading.lastNMatches) {
                this.$emit("apiCallsDone");
            }
        },
        seeAll() {
            let params = this.$route.params;
            if (this.type === "component") {
                this.$router.push(
                    `/${this.currentLocale}/${this.currentSportType}/${params.country}/${params.club}/${params.opponent}/${params.matchId}/analysis-details/league-stats-comparison`
                );
            }
        },
    },
    //   components: {
    //     MatchListDropdown,
    //     GeneralContentSkeleton,
    //   },
};
</script>

<style scoped>
.match-detail__stats-wrapper {
    margin: 0 auto;
}
.match-detail__stats-header-title {
    padding: 0 0 1rem 0;
    /* margin: 0 1rem; */
    text-align: left;
    font-family: var(--weight-600);
    font-size: 20px;
    color: var(--color-text-default-default);
}
.match-detail__stats-header {
    padding: 0 0 16px 0;
    /* margin: 0 1rem; */
    text-align: left;
    text-align: center;
    font-size: 32px;
    line-height: 120%;
    /* margin-top: 24px; */
    letter-spacing: -0.64px;
    font-family: var(--weight-600);
}
.match-detail__stats-card {
    margin: 0 1rem;
    color: var(--color-text-default-default);
    margin: 0 0 1rem 0;
}
.match-detail__stats-container {
    display: flex;
    width: 50%;
    margin-right: 0.5rem;
    font-size: 11.2px;
    align-items: center;
    width: 100%;
}
.match-detail__stats-container:last-of-type {
    margin-right: 0;
}
.match-detail__stats-title {
    font-size: var(--typography-caption-size-large);
    width: 88px;
    padding: 16px;
    letter-spacing: 0.24px;
    flex-shrink: 0;
    min-height: 52.8px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    letter-spacing: 0.2px;
}
.match-stats-web-left .dashed-box {
    border: 0 !important;
}
.match-stats-web-left .match-detail__stats-card {
    position: relative;
}
.match-stats-web-left .match-detail__stats-title {
    position: absolute;
    top: 0;
    left: 50%;
    width: 50%;
    transform: translateX(-50%);
    height: auto !important;
    font-family: var(--weight-400) !important;
    font-size: 16px;
}

@media (min-width: 768px){
    /* .match-detail__stats-wrapper {
    width: 70%;
  } */
}
</style>

<style scoped>
.match-detail__head-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0 166.67px;
    margin-bottom: 16px;
    letter-spacing: -0.64px;
    font-family: var(--weight-600);
    font-size: 32px;
    line-height: 120%;
    color: var(--color-text-default-default);
}
.match-detail-team-icon {
    width: 66.66px;
}

.match-detail__stats-title.played {
    display: block;
    color: var(--color-text-default-default);
    padding: 8px 16px;
}
.match-detail__stats-title.played .played-title {
    font-size: var(--typography-heading-size-extra-small);
    font-family: var(--weight-700);
    color: var(--color-text-default-default);
}
.match-detail__stats-title.played .played-value {
    font-size: var(--typography-heading-size-medium);
    font-family: var(--weight-600);
    letter-spacing: -0.64px;
    line-height: 120%;
    padding: 4px 0;
}
.match-detail__stats-title.played .played-draws-value {
    color: var(--color-text-default-secondary);
    font-size: var(--typography-body-size-small);
    letter-spacing: 0.64px;
}
.match-detail__stats-number {
    margin-right: 0.5rem;
    color: var(--color-text-default-default);
    font-family: var(--weight-700);
    font-size: 16px;
    letter-spacing: 0.64px;
    margin-bottom: 8px;
}
.match-detail__stats-number.right {
    margin-right: 0;
    text-align: right;
}
.match-detail__stats-number.h2h {
    padding-left: 8px;
}
.match-detail__stats-number.h2h.right {
    padding-left: 0;
    padding-right: 8px;
}
.match-detail__stats-progress-wrapper {
    height: 1rem;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    background-color: var(--color-bar-background);
    border-radius: var(--size-radius-200);
}
.match-detail__stats-progress-wrapper.right {
    justify-content: flex-start;
}
.match-detail__stats-progress-bar {
    height: 100%;
    width: 0;
    background-color: var(--success-500);
    border-radius: var(--size-radius-200) 0 0 var(--size-radius-200);
}
.match-detail__stats-progress-wrapper.right .match-detail__stats-progress-bar {
    background-color: var(--secondary-400);
}
.dashed-box {
    border: 1px dotted var(--color-border-default-default);
    padding: 7px 8px;
    box-sizing: border-box;
}
.dashed-box:nth-child(1) {
    border-left: 0;
}
.dashed-box:nth-child(2) {
    border-left: 0;
    border-right: 0;
}
.dashed-box:nth-child(3) {
    border-right: 0;
}
.played-list .match-detail__stats-card {
    margin-bottom: 0;
}
.wins-container {
    border-bottom: 1px dotted var(--color-border-default-default);
    padding: 0 4px;
    box-sizing: border-box;
}
.played-container {
    border-bottom: 1px dotted var(--color-border-default-default);
    color: var(--color-text-default-default);
}
.wins-title {
    width: auto;
    font-size: var(--typography-body-size-large);
    color: var(--color-text-default-default);
    font-family: var(--weight-700);
    min-height: unset;
    padding: 4px 16px;
    letter-spacing: 0.64px;
}
.total-wins-container {
    margin-bottom: 7.5px;
    font-size: 16px;
    letter-spacing: 0.64px;
}
.total-wins-text {
    font-size: 16px;
    font-weight: normal;
    color: var(--color-text-default-default);
    letter-spacing: 0.64px;
}
.match-detail__stats-wrapper .match-detail__stats-card .dashed-box {
    height: 42px;
    min-height: auto;
    padding-top: 0;
}
.match-detail__stats-wrapper .match-detail__stats-title {
    font-family: var(--weight-700);
    color: var(--color-text-default-default);
}

.match-details__stats-container {
    margin-bottom: 32px;
    border-radius: 8px;
}

.progress-circle {
    width: 64px;
    height: 64px;
    /* background: conic-gradient(#4DB761 0% var(--progress), var(--color-background-default-default) var(--progress) 100%); */
    /* background: conic-gradient(green 70%, #f1f1f1 30%); */
    border-radius: 50%;
    position: relative;
    transform: rotate(-180deg); /* 让起点变为顶部 */
}
.progress-circle.circle-home {
    background: conic-gradient(
        #4db761 0% var(--progress),
        var(--color-background-default-default) var(--progress) 100%
    );
}
.progress-circle.circle-away {
    background: conic-gradient(
        #26b3ff 0% var(--progress),
        var(--color-background-default-default) var(--progress) 100%
    );
}
.progress-circle:after {
    position: absolute;
    top: 7px;
    left: 7px;
    width: 50px;
    height: 50px;
    background-color: var(--color-background-default-secondary);
    display: block;
    content: attr(data-progress);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(180deg); /* 让起点变为顶部 */
    font-size: 14px;
    font-family: var(--weight-600);
}
.circle-progress-title {
    width: 120px;
    text-align: center;
    font-size: 16px;
    font-family: var(--weight-400);
    padding: 0 16px;
    box-sizing: border-box;
}
.match-stats-web-container {
    gap: 16px;
}
.match-stats-web-left {
    width: 100%;
    margin-right: 24px;
}
.match-stats-web-right {
    width: 320px;
    flex-shrink: 0;
}

.analysis-title {
    font-size: 24px;
    font-family: var(--weight-600);
    letter-spacing: -0.48px;
    margin-bottom: 4px;
    text-align: center;
    color: var(--color-text-default-default);
}
.analysis-hint-text {
    font-size: 16px;
    color: var(--color-text-default-secondary);
    text-align: center;
    margin-bottom: 24px;
}
.match-detail__stats-progress-wrapper {
    height: 12px;
}

@media(max-width: 768px) {
    /* for test */
    .match-detail__stats-wrapper .match-detail__stats-card .dashed-box {
        height: 52.8px;
        min-height: auto;
    }
    .match-details__stats-container {
        background-color: var(--color-background-default-secondary);
        border-radius: 8px;
        /* margin-top: 16px; */
        padding: 16px;
        margin-bottom: 16px;
    }
    .match-details__stats-container.page {
        margin-bottom: 64px;
    }
    .match-detail__content-container {
        background-color: var(--white-1000) !important;
    }
    .match-detail__stats-header-title {
        display: none;
    }
    .match-detail-team-icon {
        display: none;
    }
    .match-detail__head-icon {
        font-size: 24px;
        padding-top: 16px;
        letter-spacing: -0.64px;
        font-family: var(--weight-600);
    }
    .match-detail__stats-title.played .played-title {
        font-size: 16px;
        letter-spacing: 0.64px;
    }
    .match-detail__stats-title.played .played-value {
        font-size: 14px;
        letter-spacing: 0.64px;
    }
    .played-draws-value {
        color: var(--color-text-default-secondary);
    }
    .match-detail__stats-number.right-text {
        margin-left: 0.5rem;
        margin-right: 0;
    }
    .played-box {
        margin-bottom: 20px;
    }
    .match-detail__head-icon {
        padding: 0;
        justify-content: center;
    }
    .wins-title {
        padding: 8px 16px;
    }
    .wins-container {
        padding: 0;
    }
    .match-detail__stats-header {
        margin-top: 0;
        font-size: 24px;
        letter-spacing: -0.64px;
        font-family: var(--weight-600);
    }
    .dashed-box {
        border: 0;
    }
    .match-detail__stats-item-box {
        position: relative;
    }
    .match-detail__stats-number {
        font-size: 14px;
        letter-spacing: 0.64px;
        margin-bottom: 0;
    }
    .match-detail__stats-item-box .match-detail__stats-title {
        position: absolute;
        top: -8.5px;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        font-size: 16px;
        color: var(--color-text-default-default);
        font-family: var(--weight-600);
        height: auto;
        width: 80%;
        letter-spacing: 0.64px;
    }
    .match-detail__stats-item-box .match-detail__stats-number {
        margin-bottom: 8px;
    }
    .match-detail__stats-item-box .dashed-box {
        padding: 7px;
    }

    .match-detail__stats-progress-bar {
    }
    .analysis-hint-text {
        margin-bottom: 16px;
    }
    .show-more {
        width: 100%;
        text-align: center;
        padding: 8px;
        box-sizing: border-box;
        font-size: 16px;
        color: var(--color-text-default-default);
        letter-spacing: 0.64px;
    }
}
</style>
